export default {
    successful_action_title: '¡OK!',
    successful_action_text: '¡Acción ejecutada con éxito!',
    confirm_deactivate: {
        title: '¿Está seguro de que desea deshabilitar?',
        title_particular: '¿Quieres inhabilitar el elemento {{item}}?',
        title_close_chat: 'Finalizar Chat',
        text: 'El elemento se desactivará y no podrá utilizarlo hasta que lo vuelva a activar.',
        text_close_chat: 'Cuando finalice el chat, ya no será posible interactuar en este chat, ¿está seguro de que desea finalizarlo?',
        text_success: '¡El artículo {{item}} ha sido deshabilitado!',
        text_success_close_chat: '¡Chat encerrado con éxito!',
        button_confirm: 'Sí, deshabilitar.',
        button_close_chat: 'Si, finalizar chat',
    },
    confirm_delete: {
        title: '¿Está seguro de que desea eliminar?',
        title_particular: '¿Quieres inhabilitar el elemento {{item}}?',
        title_workload: '¿Está seguro de que desea eliminar esta carga útil?',
        text: 'El elemento se desactivará y no podrá utilizarlo hasta que lo vuelva a activar.',
        text_organization: 'Al eliminar esta Organización, también se eliminarán los Clientes y Grupos de Servicios vinculados a ella.' +
            'No podrá revertir esta acción, ¿está seguro de que desea continuar?',
        text_attendance_group: 'Al eliminar este Grupo de Servicios, ya no será posible ver las Tickets que pertenecen a él.' +
            'No podrá revertir esta acción, ¿está seguro de que desea continuar?',
        text_sla_config: "Está eliminando la configuración de SLA del grupo de servicios <b>'{{attendance_group_name}}'</b> y la categoría <b>'{{call_category_name}}'</b>.",
        button_confirm: 'Sí, deshabilitar.',
        text_success: '¡El artículo {{item}} ha sido eliminado!',
        text_success_sla_config: "Se eliminó el SLA para el grupo de servicio <b>'{{attendance_group_name}}'</b> y la categoría <b>'{{call_category_name}}'</b>. " +
            "<br>Ahora los tickets vinculados a este grupo de servicios y categoría ya no tienen control de SLA.",
        title_call_spam: 'Eliminar y Marcar Ticket como Spam',
        text_call_spam: 'Después de ejecutar esta acción, el ticket será <b>borrado definitivamente</b> del sistema y ' +
            'el correo electrónico que abrió este ticket será marcado como SPAM para no abrir más tickets al recibir ' +
            'correos electrónicos de este remitente. , ¿está seguro de que desea continuar?',
    },
    confirm_restore: {
        title: '¿Está seguro de que desea restaurar?',
        title_particular: '¿Quieres restaurar el elemento {{item}}?',
        text: 'El artículo se restaurará y podrás usarlo normalmente',
        button_confirm: 'Si, restaurar',
        text_success: '¡El artículo {{item}} ha sido restaurado!',
    },
    confirm_warning_action: {
        title: '¿Estás seguro?',
        title_sla_regard: '¿Quiere que se considere el SLA?',
        text_sla_regard: 'Después de esta acción, el SLA se considerará nuevamente para este ticket.',
        text_taskier_document: 'Se enviará un correo electrónico de notificación de actualización del documento {{document_type}} a todos los usuarios de la plataforma',
        title_archive_task: '¿Quieres archivar esta tarea?',
        text_archive_task: 'Después de archivar la tarea, ya no será posible actualizarla.',
        text_success_archive_task: 'Esta tarea fue archivada el {{date}}. No puede actualizar la información para esta tarea.',
        title_archive_ticket: 'Do you want to archive this ticket?',
        text_archive_ticket: 'After archiving the ticket, it will no longer be possible to update it.',
        button_confirm: 'Si, proceder.',
        title_unsubscribe: '¿Quieres cancelar tu suscripción actual?',
        text_unsubscribe: 'Al cancelar la suscripción, volverás al plan Gratuito y no se realizarán más cargos ' +
            'en tu tarjeta. Aún podrá disfrutar de los beneficios del plan actual durante el período ya pagado. ' +
            'Vea la diferencia en las características del plan',
        title_success_unsubscribe: '¡Suscripción cancelada!',
        text_success_unsubscribe: 'Tu suscripción ha sido cancelada con éxito.',
    },
    edit_success: {
        text: '¡Datos actualizados con éxito!',
        text_admin: 'Administrador actualizado correctamente!',
        text_agent: '¡Usuario actualizado correctamente!',
        text_agreed_load: '¡Carga actualizada con éxito!',
        text_attendance_group: '¡Grupo de Servicio actualizado correctamente!',
        text_attendance_type: '¡Status actualizado correctamente!',
        text_call: '¡El número de ticket {{number}} se ha actualizado correctamente!',
        text_call_config_email: '¡Configuración de Email actualizada con éxito!',
        text_category: '¡Categoría actualizada correctamente!',
        text_customer: '¡Cliente actualizado correctamente!',
        text_faq_article: '¡Artículo de FAQ actualizado correctamente!',
        text_faq_category: '¡Categoría de FAQ actualizada correctamente!',
        text_holiday: '¡Vacaciones actualizado correctamente!',
        text_organization: '¡Organización actualizada correctamente!',
        text_role: '¡Perfil de Acceso actualizado correctamente!',
        text_sla_config: '¡Configuración de SLA actualizada correctamente!',
        text_workload: '¡Carga de Trabajo actualizada correctamente!',
        text_work_type: '¡Tipo de Carga de Trabajo actualizada correctamente!',
        text_responsible_attach: '¡Responsable vinculado correctamente!',
        text_plan: '¡Plan actualizado correctamente!',
        text_task_status: '¡Status de la Tarea actualizado correctamente!',
        text_task_type: '¡Tipo de Tarea actualizado correctamente!',
        text_task: '¡La tarea número {{number}} se ha editado correctamente!',
        title_subscription: '¡Suscripción actualizada!',
        text_subscription: 'Enhorabuena, su suscripción se ha actualizado correctamente.',
    },
    save_success: {
        text: '¡Registro exitoso!',
        text_admin: 'Administrador registrado exitosamente!',
        text_agent: '¡Usuario registrado exitosamente!',
        text_agreed_load: 'Carga agregada con éxito!',
        text_attendance_group: '¡Grupo de Servicio registrado exitosamente!',
        text_attendance_type: '¡Status registrado exitosamente! {{info}}',
        text_call: '¡El número de ticket {{number}} se ha creado con éxito!',
        text_call_access: 'Acceso ticket #{{number}}',
        text_call_config_email: '¡Configuración de Email registrada correctamente!',
        text_category: '¡Categoría registrada con éxito!',
        text_customer: '¡Cliente registrado exitosamente!',
        text_faq_article: '¡Artículo de FAQ registrado exitosamente!',
        text_faq_category: '¡Categoría de FAQ registrada con éxito!',
        text_holiday: '¡Vacaciones registrado exitosamente!',
        text_organization: '¡Organización registrada con éxito!',
        text_role: '¡Perfil de Acceso registrado exitosamente!',
        text_sla_config: '¡Configuración de SLA registrada con éxito!',
        text_workload: '¡Carga de Trabajo registrada con éxito!',
        text_workload_started: '¡La actividad comenzó con éxito!',
        text_work_type: '¡Tipo de Carga de Trabajo registrada con éxito!',
        text_call_transfer: '¡Tickets transferidas con éxito!',
        text_plan: '¡Plan registrado exitosamente!',
        text_task_status: '¡Status de la Tarea registrado exitosamente!',
        text_task_type: '¡Tipo de Tarea registrado exitosamente!',
        text_task: '¡Número de tarea {{number}} registrado con éxito!',
        text_task_access: 'Acceso tarea #{{number}}',
        title_subscription: '¡Suscripción completada!',
        text_subscription: 'Felicitaciones, ha cambiado su plan de suscripción al plan {{plan}}.',
        title_subscription_trial: '¡Prueba gratuita iniciada!',
        text_subscription_trial: 'Felicitaciones, ha comenzado su período de prueba gratuito. Podrá utilizar los beneficios del plan {{plan}} hasta {{- trialEndAt}}',
    },
    call_response: {
        text_success: '¡Respuesta enviada con éxito!',
    },
    attendance_type: {
        updated_order: 'El orden introducido para este Status es el último orden de la lista. Este Status se registró con la orden {{newOrder}}.'
    },
    archived_ticket: {
        text_success: '¡Ticket archivado con éxito!',
    },
    timezone_wrong: {
        title: '¿Es correcta la configuración de la zona horaria de su cuenta?',
        text: 'Se ha identificado que probablemente se encuentre en la zona horaria de <b>{{clientTz}}</b>, ' +
            'sin embargo, su cuenta está configurada para <b>{{userTz}}</b>.<br><br> ¿Quieres ser redirigido para editar tu cuenta?',
        button_confirm: 'Si, redirigir',
        button_cancel: 'No, ignora la advertencia',
    },
    service_chat: {
        text_success_agent_transfer: 'Se ha enviado una solicitud de transferencia al usuario. Se le notificará una vez que el usuario acepte y se transfiera el chat.',
        text_success_cancel_transfer: 'Transferencia cancelada con éxito.',
        button_open_ticket: 'Quiero abrir un ticket',
    },
    remove_sla_config_from_calls: {
        title: 'Eliminar SLA de tickets abiertos',
        text: '¿Desea eliminar la configuración de SLA de los tickets aún abiertos que tienen el grupo de servicio y la categoría de la configuración que se está eliminando?',
        button_confirm: 'Sí, eliminar la configuración del ticket',
        button_deny: 'No, solo borra esta configuración',
    },
    update_sla_config_from_calls: {
        title: 'Actualizar SLA de tickets abiertos',
        text: '¿Desea actualizar la configuración de SLA para tickets abiertos que tienen este grupo y categoría de servicio?',
        button_confirm: 'Sí, actualizar la configuración del ticket',
        button_deny: 'No, solo actualice esta configuración.',
    },
    update_sla_config_from_call: {
        text: 'Después de la actualización, la configuración de SLA para ese ticket será la misma que el registro actual del grupo de servicio y la categoría para ese ticket.',
        text_success: 'La configuración de SLA para este ticket se ha actualizado de acuerdo con el registro actual del grupo de servicios y la categoría del ticket.',
    },
    update_business_time_from_calls: {
        title: 'Actualizar el Horario de Atención de los Tickets Abierto',
        text: '¿Quieres actualizar los horarios de atención de los tickets que tienen este grupo de servicios?<br><br>' +
            '<b>Advertencia:<b> Si actualizas el horario de apertura de tickets, se recalculará el SLA para aquellos que tengan un SLA.',
        text_success: '¡Grupo de apoyo actualizado con éxito! <br>Puede tomar unos minutos para que todos los tickets abiertos se actualicen con el nuevo horario de apertura.',
        button_confirm: 'Sí, actualice el ticket',
        button_deny: 'No, solo actualice este grupo',
    },
    call_not_found: {
        title: 'Ticket no encontrado',
        text: 'No se encontró el ticket número {{number}}, confirme que ha ingresado el número correcto y que pertenece al grupo de servicio',
    },
    tinymce_paste_image_title: 'Acción no permitida',
    tinymce_paste_image_text: 'No es posible agregar una imagen al cuerpo del mensaje',
    tinymce_image_upload: {
        title: '¡Problema al subir imágenes!',
        text: 'No pudimos cargar una de las imágenes dentro de su mensaje. Intenta eliminarlo y agregarlo.',
    },
    workload_already_finished: {
        title: 'Actividad ya terminada',
        text: 'Esta actividad ya se ha completado, actualice la página.'
    },
    days_left_to_delete_tenant: '{{time}} será borrado definitivamente',
    corporate_plan: {
        title: 'Plan Corporate',
        text: 'Ponte en contacto con nosotros a través de nuestro correo electrónico {{- link}}',
    },
}
